export default __webpack_public_path__ + "static/media/pvilla7-3.721ac49d.jpg";